module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./icon.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/icon.md
// module id = k4Jh
// module chunks = 0